function ss(key) {
  if (typeof sessionStorage === "undefined") return "";
  const v = sessionStorage.getItem(key);
  return v && v !== "null" && v !== "undefined" ? v : "";
}

// Only the signed upload token and the non-secret org/app (needed by the backend
// to route to the tenant DB) go in the QR — never session credentials.
export function getCrossDeviceUploadUrl(uploadToken, mode) {
  if (!uploadToken) return "";
  const origin = process.env.REACT_APP_FRONTEND_URL
    || (typeof window !== "undefined" ? window.location.origin : "");

  const modeParam = mode ? `&mode=${encodeURIComponent(mode)}` : "";
  return `${origin}/ipd-mobile-scan?t=${encodeURIComponent(uploadToken)}&org=${encodeURIComponent(ss("ORG_CODE"))}&app=${encodeURIComponent(ss("APP_MODE"))}${modeParam}`;
}
